import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/municipios';

export default {
    getMunicipioById(idMunicipio) {
        return http.get({
            url: baseUrl + `/${idMunicipio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeMunicipio')
        });
    }
};
